import React, {useState} from "react";
import styles from "./FormLabel.module.css";

interface FormLabelInterface {
    label: string;
    cols?: 2 | 3 | undefined;
}

export const FormLabel: React.FC<FormLabelInterface> = ({ label, cols }) => {
    return (
      <div className={styles.container}>
        {!!cols && cols === 2 ? (
          <>
            <span className={styles.label} style={{ flex: "0 0 20%", textAlign: "start" }}>{label}</span>
            <span className={styles.breakLine}></span>
          </>
        ) : (
          <>
            <span className={styles.breakLine}></span>
            <span className={styles.label}>{label}</span>
            <span className={styles.breakLine}></span>
          </>
        )}
      </div>
    );
};
